import { RefObject, useEffect, useRef } from 'react'

export default function useClickOutside<T extends HTMLElement>(ref: RefObject<T | null>, callback: () => void): void {
  const callbackRef = useRef<() => void>(callback)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      const target = event.target as Node
      // A click that unmounts its own target (e.g. the menu's "Show more" button) detaches the
      // node before this document listener runs, so contains() would misread it as outside
      if (!target.isConnected) return
      if (ref.current && !ref.current.contains(target)) {
        callbackRef.current()
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [callbackRef, ref])
}
